<template>
  <a-spin :spinning="spinning">
    <a-form :form="form">
      <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入用户名' }] }]" />
      </a-form-item>
      <a-form-item label="账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['username', { rules: [{ required: true, message: '请输入账号' }] }]" />
      </a-form-item>
      <template v-if="!aid">
        <a-form-item label="密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            name="link"
            type="password"
            v-decorator="['password', { rules: [{ required: true, message: '请输入密码' }] }]"
          />
        </a-form-item>
        <a-form-item label="重复密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            name="link"
            type="password"
            v-decorator="['password_repeat', { rules: [{ required: true, message: '请再次输入密码' }] }]"
          />
        </a-form-item>
      </template>
      <a-form-item label="上传头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <img-upload name="avatar" v-decorator="['avatar', { rules: [] }]" />
      </a-form-item>
      <a-form-item label="选择角色" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          placeholder="请选择角色"
          name="role"
          mode="multiple"
          optionFilterProp="children"
          v-decorator="[
            'role',
            {
              rules: [{ required: true, message: '请选择角色' }]
            }
          ]"
        >
          <a-select-option v-for="item in treeData" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { ImgUpload } from '@/components'
import { requestData, requestGet } from '@/api/api'
import { handleSelectArr } from '@/utils/util'

const fields = ['username', 'password', 'password_repeat', 'name', 'avatar', 'role']

export default {
    name: 'ModelForm',
    props: {
        aid: {
            type: Number,
            default: null
        }
    },
    components: {
        ImgUpload
    },
    data () {
        return {
            spinning: false, // 页面加载
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            treeData: [],
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        if (this.aid) {
            this.getFormData(this.aid) // 获取广告信息
        }
        this.getRoleLists() // 获取角色下拉
    },
    methods: {
        /**
         * 获取角色列表
         * @jdy
         * @2020-11-16
         */
        getRoleLists () {
            this.spinning = true
            requestGet('/admins/roles/select')
                .then(res => {
                    this.treeData = res.result
                })
                .finally(() => {
                    this.spinning = false
                })
        },
        /**
         * 获取编辑信息
         * id
         * @param
         */
        getFormData (id) {
            this.spinning = true
            requestGet('/admins/users/' + id)
                .then(res => {
                    res.result.role = handleSelectArr(res.result.role)
                    this.form.setFieldsValue(pick(res.result, fields))
                })
                .finally(() => {
                    this.spinning = false
                })
        },
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
                        let url = '/admins/users/create'
                        let methods = 'post'
                        if (this.aid) {
                            // 有aid编辑，没aid创建
                            url = '/admins/users/' + this.aid
                            methods = 'put'
                        }
                        requestData(url, methods, values)
                            .then(res => {
                                this.$notification.success({
                                    message: res.msg
                                })
                                resolve(true) // 关闭弹出层
                            })
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style>
.avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
}
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>
